// extracted by mini-css-extract-plugin
export default {"DeviceList":"BookDevice_DeviceList__9XASC","igsLogo":"BookDevice_igsLogo__ANtXv"};